import { C, P0, R, S, abs, disc, max, moodK } from '../../geometry';

export const petals = {
  name: 'Petals',
  colors: ['#E5484D', '#E3A008'],
  draw(m, t) {
    let d = 31,
      L = 9,
      W = 4.5,
      spin = 6 * S(t * 0.6),
      pose = P0(),
      pulse = () => 0;
    if (m === 'happy') {
      L = 11 + 2 * abs(S(t * 7));
      spin = 20 * S(t * 4);
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: the flower keeps turning.
    if (m === 'thinking') spin = t * 50;
    if (m === 'talking') pulse = (i) => 3 * max(0, S(t * 9 - i * 1.05));
    if (m === 'surprised') {
      d = 35;
      L = 12;
    }
    if (m === 'paused') {
      d = 27;
      L = 5;
      W = 3;
      spin = 2 * S(t * 0.5);
    }
    const strokes = [...Array(6)].map((_, i) => {
      const a = (i * 60 - 90) * R,
        l = L + pulse(i),
        cx = 50 + (d + pulse(i) * 0.5) * C(a),
        cy = 52 + (d + pulse(i) * 0.5) * S(a);
      const pts = [...Array(10)].map((_, k) => {
        const u = (k / 9) * 2 * Math.PI,
          x = l * C(u),
          y = W * S(u);
        return [cx + x * C(a) - y * S(a), cy + x * S(a) + y * C(a)];
      });
      return { c: i % 2 ? 'b' : 'a', pts, n: 14, spin };
    });
    return { strokes, eyes: { x: 50, y: 52 }, pose };
  },
  eyesOn: 'b',
  solid(f, m, t) {
    f.strokes.forEach((s) => {
      s.fill = true;
      s.c = 'a';
    });
    f.strokes.push({
      c: 'b',
      fill: true,
      pts: disc(50, 52, 15.5 * moodK(m, t)),
      n: 24,
    });
    return f;
  },
};
